module.exports = __webpack_public_path__ + "bg-body.jpg?d2b710cc86247a2913406ae779757020";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bg-body.jpg
// module id = 121
// module chunks = 0